import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { MoneyPipe } from '@shared/pipes/money.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MoneyPipe],
  selector: 'aux-investigator-forecast-saved-source-banner',
  templateUrl: './investigator-forecast-saved-source-banner.component.html',
})
export class InvestigatorForecastSavedSourceBannerComponent {
  @Input() amount?: number;
  @Input() source?: string;
}
